import ButtonsDocs from "./docs/buttons/ButtonsDocs";
import BreadcrumbsDocs from "./docs/breadcrumbs/BreadcrumbsDocs";
import CalloutsDocs from "./docs/callouts/CalloutsDocs";
import CardsDocs from "./docs/cards/CardsDocs";
import ColorsDocs from "./docs/colors/ColorsDocs";
import CheckboxesDocs from "./docs/checkboxes/CheckboxesDocs";
import ChipsDocs from "./docs/chips/ChipsDocs";
import DayHeadersDocs from "./docs/day-headers/DayHeadersDocs";
import DialogsDocs from "./docs/dialogs/DialogsDocs";
import DividersDocs from "./docs/dividers/DividersDocs";
import FieldsDocs from "./docs/fields/FieldsDocs";
import IconsDocs from "./docs/icons/IconsDocs";
import LayoutsDocs from "./docs/layouts/LayoutsDocs";
import LinksDocs from "./docs/links/LinksDocs";
import LoadingOverlaysDocs from "./docs/loading-overlays/LoadingOverlaysDocs";
import MenusDocs from "./docs/menus/MenusDocs";
import NavigatorsDocs from "./docs/navigators/NavigatorsDocs";
import PeriodNavigatorsDocs from "./docs/period-navigators/PeriodNavigatorsDocs";
import PersonBadgesDocs from "./docs/person-badges/PersonBadgesDocs";
import RadioGroupsDocs from "./docs/radio-groups/RadioGroupsDocs";
import RadiusDocs from "./docs/radius/RadiusDocs";
import ScrollbarsDocs from "./docs/scrollbars/ScrollbarsDocs";
import SelectionListsDocs from "./docs/selection-lists/SelectionListsDocs";
import ShadowsDocs from "./docs/shadows/ShadowsDocs";
import SpacingDocs from "./docs/spacing/SpacingDocs";
import SwitchesDocs from "./docs/switches/SwitchesDocs";
import TablePatternsDocs from "./docs/table-patterns/TablePatternsDocs";
import TabsDocs from "./docs/tabs/TabsDocs";
import ToastsDocs from "./docs/toasts/ToastsDocs";
import TooltipDocs from "./docs/tooltips/TooltipDocs";
import TypographyDocs from "./docs/typography/TypographyDocs";

const foundationDocs = [
  { key: "typography", title: "Typography", anchorId: "ds-doc-typography", Component: TypographyDocs },
  { key: "colors", title: "Colors", anchorId: "ds-doc-colors", Component: ColorsDocs },
  { key: "icons", title: "Icons", anchorId: "ds-doc-icons", Component: IconsDocs },
  { key: "radius", title: "Radius", anchorId: "ds-doc-radius", Component: RadiusDocs },
  { key: "shadows", title: "Shadows", anchorId: "ds-doc-shadows", Component: ShadowsDocs },
  { key: "scrollbars", title: "Scrollbars", anchorId: "ds-doc-scrollbars", Component: ScrollbarsDocs },
  { key: "layouts", title: "Layout", anchorId: "ds-doc-layouts", Component: LayoutsDocs },
  { key: "spacing", title: "Spacing", anchorId: "ds-doc-spacing", Component: SpacingDocs },
];

const componentDocs = [
  { key: "breadcrumbs", title: "Breadcrumbs", anchorId: "ds-doc-breadcrumbs", Component: BreadcrumbsDocs },
  { key: "buttons", title: "Buttons", anchorId: "ds-doc-buttons", Component: ButtonsDocs },
  { key: "callouts", title: "Callouts", anchorId: "ds-doc-callouts", Component: CalloutsDocs },
  { key: "cards", title: "Cards", anchorId: "ds-doc-cards", Component: CardsDocs },
  { key: "checkboxes", title: "Checkboxes", anchorId: "ds-doc-checkboxes", Component: CheckboxesDocs },
  { key: "chips", title: "Chips", anchorId: "ds-doc-chips", Component: ChipsDocs },
  { key: "dayHeaders", title: "Day Headers", anchorId: "ds-doc-day-headers", Component: DayHeadersDocs },
  { key: "dialogs", title: "Dialogs", anchorId: "ds-doc-dialogs", Component: DialogsDocs },
  { key: "dividers", title: "Dividers", anchorId: "ds-doc-dividers", Component: DividersDocs },
  {
    key: "fields",
    title: "Fields",
    anchorId: "ds-doc-fields",
    Component: FieldsDocs,
  },
  { key: "links", title: "Links", anchorId: "ds-doc-links", Component: LinksDocs },
  {
    key: "loadingOverlays",
    title: "Loading Overlays",
    anchorId: "ds-doc-loading-overlays",
    Component: LoadingOverlaysDocs,
  },
  { key: "menus", title: "Menus", anchorId: "ds-doc-menus", Component: MenusDocs },
  { key: "navigators", title: "Navigators", anchorId: "ds-doc-navigators", Component: NavigatorsDocs },
  {
    key: "periodNavigators",
    title: "Period Navigators",
    anchorId: "ds-doc-period-navigators",
    Component: PeriodNavigatorsDocs,
  },
  {
    key: "personBadges",
    title: "Person Badges",
    anchorId: "ds-doc-person-badges",
    Component: PersonBadgesDocs,
  },
  { key: "radioGroups", title: "Radio Groups", anchorId: "ds-doc-radio-groups", Component: RadioGroupsDocs },
  {
    key: "selectionLists",
    title: "Selection Lists",
    anchorId: "ds-doc-selection-lists",
    Component: SelectionListsDocs,
  },
  { key: "switches", title: "Switches", anchorId: "ds-doc-switches", Component: SwitchesDocs },
  { key: "tables", title: "Tables", anchorId: "ds-doc-tables", Component: TablePatternsDocs },
  { key: "tabs", title: "Tabs", anchorId: "ds-doc-tabs", Component: TabsDocs },
  { key: "toasts", title: "Toasts", anchorId: "ds-doc-toasts", Component: ToastsDocs },
  { key: "tooltip", title: "Tooltip", anchorId: "ds-doc-tooltip", Component: TooltipDocs },
].sort((left, right) => left.title.localeCompare(right.title, "de", { sensitivity: "base" }));

export const designSystemDocGroups = [
  {
    key: "foundations",
    title: "Foundations",
    description: "Grundlagen, Token und Layout-Basics für das System.",
    docs: foundationDocs,
  },
  {
    key: "components",
    title: "Components",
    description: "Interaktive Bausteine und zusammengesetzte Muster in alphabetischer Reihenfolge.",
    docs: componentDocs,
  },
];

export const designSystemDocs = designSystemDocGroups.flatMap(({ docs }) => docs);
